import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoachingRequestPriceComponent } from './coaching-request-price/coaching-request-price.component';
import { ServicePriceComponent } from './service-price/service-price.component';
import { KzStickerModule } from '../../../../kz-ui/ui/sticker/kz-sticker.module';



@NgModule({
  declarations: [
    CoachingRequestPriceComponent,
    ServicePriceComponent,
  ],
  exports: [
    ServicePriceComponent,
    CoachingRequestPriceComponent
  ],
  imports: [
    CommonModule,
    KzStickerModule,
  ]
})
export class ProPriceModule { }
